import { Picture } from '@/components/image/Image';
import { Card } from '@/components/sections/Card';
import SiClose from '@/icons/SiClose';
import { ImageMetadata } from '@/services/api/hooks/images';
import { FunctionComponent, useState } from 'react';
import { Button } from '../../Button';

interface GalleryModalCardProps {
  image: ImageMetadata;
  onSelectCallback: (image: ImageMetadata) => void;
  onDeleteCallback: () => void;
}

const GalleryModalCard: FunctionComponent<GalleryModalCardProps> = ({ image, onSelectCallback, onDeleteCallback }) => {
  const [showDelete, setShowDelete] = useState(false);

  return (
    <Card
      role="button"
      onClick={() => onSelectCallback(image)}
      onMouseEnter={() => {
        setShowDelete(true);
      }}
      onMouseLeave={() => {
        setShowDelete(false);
      }}
      key={image.id}
      className="overflow-clip h-fit flex flex-col gap-2 cursor-pointer"
    >
      <div className="relative flex items-center justify-center">
        <Picture image={image} containerHeight={150} containerWidth={200} />
        {showDelete && (
          <Button
            onClick={e => {
              e.stopPropagation();
              onDeleteCallback();
            }}
            className="hover:bg-red-700 absolute right-0 top-0 w-[32px] h-[32px] rounded-full bg-red-500 text-white p-1 mr-3 mt-3"
          >
            <SiClose className="text-3xl" />
          </Button>
        )}
      </div>
      <div className="p-3 leading-tight border-t border-secondary-std">
        <p>{image.name}</p>
      </div>
    </Card>
  );
};

export default GalleryModalCard;
